import { Col, Divider, Row, Space } from 'antd';
import Button from 'atoms/Button';
import DateTime from 'atoms/DateTime';
import { MomentFormat } from 'atoms/DateTime/MomentFormat';
import Progress from 'atoms/Progress';
import { capitalize } from 'lodash';
import UserProfile from 'molecules/UserProfile';
import moment from 'moment';
import GroupTagList from 'organisms/GroupTagList';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import {
  FEEDBACK_TYPE,
  PRIVATE_ROUTE,
  TODO_ICONS,
  TODO_TYPE,
  UPDATES_TYPE,
} from 'utils/constants';

function StandupSummaryWorkUpdate({ data, isViewed, createdAt, updatedAt }) {
  const {
    data: { blockers, goalsAchieved, goalsActive, participation },
    title,
    createdBy: user,
    type,
  } = data;
  return (
    <div>
      <div className="update-template-header">
        <Row className="title-row" align="middle">
          <Col>{TODO_ICONS[type]}</Col>
          <Col className="title">{title}</Col>
        </Row>
        <div className="time">
          <DateTime date={isViewed ? updatedAt : createdAt} fromNow />
        </div>
      </div>
      <div className="update-template-body">
        <div className="result-stats">
          <Progress width="20px" percent={participation} strokeWidth={14} />
          <div className="percent">{participation}%</div>
          <div className="stats-description">Checked-in with stand-ups</div>
        </div>
        <div className="flex">
          <div className="count">
            <span className="green">{goalsAchieved}</span>Goals Achieved
          </div>
          <div className="count">
            <span className="purple">{goalsActive}</span>Active Goals
          </div>
          <div className="count">
            <span className="red">{blockers}</span>Blockers
          </div>
        </div>
      </div>
      {/* commented for future use */}
      {/* <div className="update-template-footer">
        <div>
          <Button
            name={<FormattedMessage id="workUpdate.viewResult" />}
            onClick={() =>
              history.push(
                `${
                  feedbackType === FEEDBACK_TYPE.SURVEY
                    ? '/feedback/survey'
                    : '/feedback/poll'
                }/${feedbackId}/summary`
              )
            }
          />
        </div>
      </div> */}
    </div>
  );
}

export default withRouter(StandupSummaryWorkUpdate);
